import type { AnyAction } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

import { canonicalPickerApi } from 'api/canonicalPicker'
import type { PickerSource } from 'slices/aiConversations/pickerTypes'

import { describeCanonicalPicks, failToDescribeCanonicalPicks } from '.'
import type { CanonicalLevel, PickerSliceState } from './types'

export type PickerDispatch = ThunkDispatch<
  { picker: PickerSliceState },
  unknown,
  AnyAction
>

/**
 * Asks a level's smart source to name picks thanx-ai sent without a label,
 * level 2 within level 1's products. Picks it can't name are kept so the
 * merchant can ask again.
 */
const describeUnlabeledPicks =
  ({
    pickerId,
    level,
    source,
    ids,
    scope,
  }: {
    pickerId: number
    level: CanonicalLevel
    source: PickerSource
    ids: string[]
    scope: string[] | null
  }) =>
  async (dispatch: PickerDispatch) => {
    if (ids.length === 0) return

    const request = dispatch(
      canonicalPickerApi.endpoints.getPickerRowsByKey.initiate({
        source,
        kind: 'product',
        keys: ids,
        scope,
      })
    )
    const { data } = await request
    request.unsubscribe()
    dispatch(
      data
        ? describeCanonicalPicks({
            pickerId,
            level,
            source: source.name,
            ids,
            rows: data.rows,
          })
        : failToDescribeCanonicalPicks({
            pickerId,
            level,
            source: source.name,
            ids,
          })
    )
  }

export default describeUnlabeledPicks
